module.exports = __webpack_public_path__ + "static/media/Muli-Regular.ec2818d8.ttf";